
import React from "react";
import {callAnalyticsAPI} from "../../api/user"

const fyponAreas = ['The Fypon Advantage','Explore Fypon','New Products']

class NavigationButtonsList extends React.Component {

    // componentDidMount() {

    //     console.log(this.props)
    // }
    setDisplayData = (val) => {


        if(val.type === "redirect") {

            const reqData = {}
            let user_id = sessionStorage.getItem("user_id");
            if (user_id) {
                reqData.user_id = user_id;
                reqData.area_id = val.area;
                reqData.resource_id = val.key;
                reqData.resource_type = "redirect";
                reqData.prev_area = 0;
                reqData.spent_time = 0;
                reqData.total_time = 0;
                reqData.video_status = "";
                reqData.download = 0;
                reqData.guided_mode = 0;
                callAnalyticsAPI(reqData)
            }

            if(val.key === "thermatru_tools_support_btn6"){
                return;

            }

            window.open(val.path, '_blank');
            return;
        }

        if(val.type === "navigationbuttonlist") {
            this.props.changeModalContent(val.contentKey)
            return;
        }

        this.props.setDisplayOnlyView(val)
    }

    render() {

        let fyponclass = "";
        if(this.props.modalContentInfo.styleref && this.props.modalContentInfo.styleref === "fypon_explore_more_tools"){
            fyponclass = "fypon_btn";
        }


        return(
            <div className="tab-pane fade show active"  role="tabpanel" aria-labelledby="home-tab">
                        
                <div className={`popup_div3 modal_description_div  `}>
                        <div className="popup_top_line"></div>
                        <div className="py-4 pop_btn_heading">{this.props.modalContentInfo && this.props.modalContentInfo.discription}</div>
                        <div className={`${fyponclass}`}>
                        {
                          this.props.buttonListArray &&  this.props.buttonListArray.map(val => 
                          <a key={val.title} onClick={() => this.setDisplayData(val)} className="btn veris_btn" href="#"><span>{val.title}</span></a>)
                        }
                        </div>
                        
                       
                        {this.props.modalContentInfo.footerdiscription  &&  <div className="modal_buttonList_footer_description py-4">
                            Please contact Anna Palagi for PR and Media inquiries or to request a <br />guided media tour. <a href="mailto:apalagi@ampagency.com">apalagi@ampagency.com</a> / 402.850.9820
                        </div>}
                       
                            
                </div>

            
            </div>
            )
    }

}


export default NavigationButtonsList